import { render, staticRenderFns } from "./danweigongling.vue?vue&type=template&id=525f5c67&"
import script from "./danweigongling.vue?vue&type=script&lang=js&"
export * from "./danweigongling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports